module.exports = __webpack_public_path__ + "src/img/image.f63358ed.svg";